import React from "react";
import ClassCardSection6 from "./ClassCardSection6";
import play1 from "../../../images/galleryimage/play1.jpeg"
import play2 from "../../../images/galleryimage/play2.jpeg"
import play3 from "../../../images/galleryimage/play3.jpeg"
import play4 from "../../../images/galleryimage/play4.jpeg"
import play5 from "../../../images/galleryimage/play5.jpeg"
import play6 from "../../../images/galleryimage/play6.jpeg"
import play7 from "../../../images/galleryimage/play7.jpeg"
import play8 from "../../../images/galleryimage/play8.jpeg"
import play9 from "../../../images/galleryimage/play9.jpeg"
import play10 from "../../../images/galleryimage/play10.jpeg"
import play11 from "../../../images/galleryimage/play11.jpeg"
import play12 from "../../../images/galleryimage/play12.jpeg"
import dance10 from "../../../images/galleryimage/dance10.JPG"
import act6 from "../../../images/galleryimage/act6.jpg"
const ClassGallerySection6 = () => {
  return (
    <div id="classwise overflow-hidden ">
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mx-5 lg:mt-56 mt-32 lg:mx-14 lg:w-full ">
      <ClassCardSection6 image={play1} />
      <ClassCardSection6 image={play2} />
      <ClassCardSection6 image={play11} />
      <ClassCardSection6 image={play4}/>
      <ClassCardSection6 image={play12} />
      <ClassCardSection6 image={play6} />
      <ClassCardSection6 image={play7} />
      <ClassCardSection6 image={play8} />
      <ClassCardSection6 image={play9} />
      <ClassCardSection6 image={play10} />
      <ClassCardSection6 image={act6}/>
      <ClassCardSection6 image={dance10} />
    </div>
    </div>
  );
};

export default ClassGallerySection6;
